import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { MealTypeResponse } from "../openapi/client";

const initialState: MealTypeResponse[] = [];

export const mealTypesSlice = createSlice({
  name: "mealTypes",
  initialState,
  reducers: {
    setMealTypes: (state, action: PayloadAction<any>) => {
      return [...action.payload];
    },
  },
});

export const { setMealTypes } = mealTypesSlice.actions;
export default mealTypesSlice.reducer;
